import { css } from 'styled-components';

export const shimmer = css`
  background: linear-gradient(
    -45deg,
    ${({ theme }) => (theme.isDark ? theme.colors.white : theme.colors.grayLightest)} 40%,
    ${({ theme }) => (theme.isDark ? theme.colors.grayExtraLight : theme.colors.white)} 50%,
    ${({ theme }) => (theme.isDark ? theme.colors.white : theme.colors.grayLightest)} 60%
  );
  background-size: 300%;
  background-position-x: 0;
  animation: shimmer 3s infinite linear;

  @keyframes shimmer {
    to {
      background-position-x: -300%;
    }
  }
`;

export const scrollbar = css`
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.white};
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.gray};
    border-radius: 10px;
    border: 2px solid ${({ theme }) => theme.colors.white};
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.grayDark};
  }
`;

export const glass = (blur: string = '3px') => css`
  background: ${({ theme }) => theme.colors.modalOverlay};
  backdrop-filter: blur(${blur});
  -webkit-backdrop-filter: blur(${blur});
`;

export const pageCard = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.borders.bigBorderRadius};
  padding-block: 2rem;
  background: ${({ theme }) => theme.colors.bannerBackground};
`;

export const pageCardTitle = css`
  color: ${({ theme }) => theme.colors.black};
  font-weight: 700;
  font-size: 1.375rem;
  padding-bottom: 2rem;
  font-family: ${({ theme }) => theme.fonts.Poppins};
`;

export const fadeInFromTop = css`
  animation: fadeInFromTop 0.3s ease-out;

  @keyframes fadeInFromTop {
    from {
      transform: translateY(-50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const fadeIn = css`
  animation: fadeIn 0.3s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const spin = css`
  animation: spin 1.5s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const bankLogoDarkModeFills = css`
  ${({ theme }) =>
    theme.isDark &&
    css`
      svg {
        /* logos drawn with the default black fill (mollie, kraken) */
        path:not([fill]):not([style]):not([class]),
        /* paysera text */
        path[fill='#000099'],
        /* LHV */
        path[fill='#191817'],
        /* bitcoin / bitcoin cash text */
        path[fill='#4d4d4d'],
        path[fill='#4D4D4D'],
        /* wise */
        path[fill='#163300'],
        /* payoneer */
        path[fill='#252526'],
        /* paypal (all blues -> official monochrome white mark) */
        path[fill='#0070e0'],
        path[fill='#003087'],
        path[fill='#001c64'],
        /* stripe */
        path[fill='#635BFF'],
        /* litecoin (class-based internal stylesheet) */
        .st0 {
          fill: ${theme.colors.staticWhite};
        }

        /* ethereum / ripple use inline style attributes, which only !important can override;
           the browser serializes the style attribute as rgb(), so match both notations */
        path[style*='#3b3b3b'],
        path[style*='rgb(59, 59, 59)'],
        path[style*='#434c54'],
        path[style*='rgb(67, 76, 84)'] {
          fill: ${theme.colors.staticWhite} !important;
        }
      }

      /* revolut is an embedded PNG bitmap (the only logo with an <image>), so recolor via filter */
      svg:has(image) {
        filter: brightness(0) invert(1);
      }
    `}
`;

export const requiredInputAsterisk = css`
  &::after {
    content: '*';
    color: ${({ theme }) => theme.colors.pink};
    position: absolute;
    right: -8px;
    top: -4px;
  }
`;
